import { GetServerSideProps } from 'next/types';

import Layout from '@/components/layout/LayoutWrapper';
import SubscriptionExtensionFlow from '@/components/SimplifiedSignup/configs/SubscriptionExtension/Flow';
import { SimplifiedSignupContextProvider } from '@/components/SimplifiedSignup/Context';
import { shapeConfigForParams } from '@/components/SimplifiedSignup/Context/utils';
import SubscriptionExtensionLayout from '@/components/SubscriptionExtension';
import { InitRequest } from '@/hooks/store/useInitState';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const SubscriptionExtension = () => {
	return (
		<Layout pageName="subscription-extension">
			<SimplifiedSignupContextProvider flowConfig={SubscriptionExtensionFlow}>
				<SubscriptionExtensionLayout />
			</SimplifiedSignupContextProvider>
		</Layout>
	);
};

export default SubscriptionExtension;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.PRICES, InitRequest.USER],
		shapeConfigForParams(SubscriptionExtensionFlow),
	);

	return {
		props: {
			initialState,
		},
	};
};
